import { render, staticRenderFns } from "./AdminSupplierAttributions.vue?vue&type=template&id=2d546941&scoped=true&"
import script from "./AdminSupplierAttributions.vue?vue&type=script&lang=js&"
export * from "./AdminSupplierAttributions.vue?vue&type=script&lang=js&"
import style0 from "./AdminSupplierAttributions.vue?vue&type=style&index=0&id=2d546941&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d546941",
  null
  
)

export default component.exports